import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import store from "stores/store";
import ExportedImage from "next-image-export-optimizer";
import { getAltTextFromGeneralImage, getImageUrlFromGeneralImage } from "utils/imageHelpers";
import { use4K } from "@/lib/utils";

const HeartEffect: React.FC = () => {
    if (!store) {
        throw Error("Component was not setup correctly");
    }

    const { globalLocalized } = store;

    const isStele = use4K();

    const heartConfigs = [
        { size: 400, delay: 0, duration: 2, x: 100, y: "-650%" },
        { size: 250, delay: 0.25, duration: 2, x: 300, y: "-950%" },
        { size: 280, delay: 0.5, duration: 2, x: 0, y: "-850%" },
        { size: 300, delay: 0.75, duration: 2, x: 250, y: "-750%" },
    ];

    const heartConfigsRight = [
        { size: 400, delay: 0, duration: 2, x: -200, y: "-650%" },
        { size: 250, delay: 0.25, duration: 2, x: 0, y: "-850%" },
        { size: 280, delay: 0.5, duration: 2, x: -200, y: "-750%" },
    ];

    const heartConfigsMobile = [
        { size: 150, delay: 0, duration: 2, x: 100, y: "-265%" },
        { size: 75, delay: 0.25, duration: 2, x: 300, y: "-295%" },
        { size: 125, delay: 0.5, duration: 2, x: 0, y: "-285%" },
        { size: 175, delay: 0.75, duration: 2, x: 250, y: "-275%" },
    ];

    const heartConfigsRightMobile = [
        { size: 200, delay: 0, duration: 2, x: -200, y: "-265%" },
        { size: 150, delay: 0.25, duration: 2, x: 0, y: "-285%" },
        { size: 180, delay: 0.5, duration: 2, x: -200, y: "-275%" },
    ];

    const config = isStele ? heartConfigs : heartConfigsMobile;
    const configRight = isStele ? heartConfigsRight : heartConfigsRightMobile;

    return (
        <>
            <div className="absolute flex h-screen w-screen items-center justify-center">
                <div className="4k:w-[1080px] pointer-events-none relative bottom-0 left-0 h-screen w-full overflow-hidden md:max-w-[calc(56.25vh-16px)]">
                    {config.map((config, index) => (
                        <motion.div
                            key={index}
                            className="4k:left-[200px] 4k:absolute 4k:bottom-0 absolute left-[5%]"
                            style={{
                                width: config.size,
                                height: config.size,
                            }}
                            initial={{ y: isStele ? "100%" : "500%", opacity: 1, scale: 0, x: config.x }}
                            animate={{
                                y: config.y,
                                scale: [0, 1, 0.5, 0],
                                rotate: [0, -20, 10, -30, 20, 0],
                            }}
                            transition={{
                                duration: config.duration,
                                delay: config.delay,
                                repeat: 0,
                                times: [0, 0.3, 0.9, 1],
                            }}
                        >
                            {globalLocalized?.heartEffect !== undefined && globalLocalized?.heartEffect !== null && (
                                <div>
                                    <ExportedImage
                                        src={getImageUrlFromGeneralImage(globalLocalized.heartEffect)}
                                        alt={getAltTextFromGeneralImage(globalLocalized.heartEffect)}
                                        layout="fill"
                                        objectFit="contain"
                                    />
                                </div>
                            )}
                        </motion.div>
                    ))}
                </div>
                {isStele && (
                    <div className="absolute bottom-0 right-0 h-screen w-[1080px] overflow-hidden">
                        {configRight.map((config, index) => (
                            <motion.div
                                key={index}
                                className="absolute bottom-[1000px] right-[200px]"
                                style={{
                                    width: config.size,
                                    height: config.size,
                                }}
                                initial={{ y: "100%", opacity: 1, scale: 0, x: config.x }}
                                animate={{
                                    y: config.y,
                                    scale: [0, 1, 0.5, 0],
                                    rotate: [0, 30, -10, 20, -30, 0],
                                }}
                                transition={{
                                    duration: config.duration,
                                    delay: config.delay,
                                    repeat: 0,
                                    times: [0, 0.3, 0.9, 1],
                                }}
                            >
                                {globalLocalized?.heartEffect !== undefined &&
                                    globalLocalized?.heartEffect !== null && (
                                        <div>
                                            <ExportedImage
                                                src={getImageUrlFromGeneralImage(globalLocalized.heartEffect)}
                                                alt={getAltTextFromGeneralImage(globalLocalized.heartEffect)}
                                                layout="fill"
                                                objectFit="contain"
                                            />
                                        </div>
                                    )}
                            </motion.div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default HeartEffect;
